import { orderReservedByLocker } from 'global/Models/lockerModel';
import OmParcelOrderModel from 'global/Models/omParcelOrderModel';
import { FC } from 'react';

type Props = {
  orderReservationData?: orderReservedByLocker;
};

const ReservedLockerContent: FC<Props> = ({ orderReservationData }) => {
  return orderReservationData ? (
    <>
      <p className='py-5 text-base'> {OmParcelOrderModel.reservedLockerOrderContent}</p>
      {OmParcelOrderModel.reservedLockerInfo(orderReservationData)}
    </>
  ) : (
    <></>
  );
};

export default ReservedLockerContent;
